<template>
  <div id="CoursewareManager" v-loading="loading" class="">
    <a :href="downLoadUrl" download @click="downLoad" style="display: none"></a>
    <el-tabs
      v-model="editableTabsValue"
      type="card"
      @tab-click="handleClick"
      @tab-remove="removeTab"
    >
      <el-tab-pane label="全部" name="全部">全部</el-tab-pane>
      <el-tab-pane
        v-for="item in editableTabs"
        :key="item.id"
        :label="item.typeName"
        :name="item.id"
      >
      </el-tab-pane>
    </el-tabs>
    <el-form
      ref="query"
      :model="query"
      label-width="120px"
      style="width: 500px; transition: all 0.5s"
      v-show="isShowQuery"
    >
      <el-form-item label="课件名称：" prop="professionId">
        <el-select
          v-model="query.professionId"
          @change="chooseCourseName"
          size="small"
          clearable
          filterable
          placeholder="请选择"
        >
          <el-option
            v-for="(item, index) in categoryList"
            :key="item"
            :label="item"
            :value="index"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="课程内容：" prop="courseName">
        <el-input
          v-model="query.courseName"
          size="small"
          clearable
          placeholder="请输入"
          v-show="notTypes"
        ></el-input>
        <el-select
          v-model="query.courseName"
          placeholder="请选择"
          v-show="chooseTypes"
        >
          <el-option
            v-for="(item, index) in optionType"
            :key="item.value"
            :label="item"
            :value="index + 1"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item style="text-align: right">
        <el-button type="primary" size="small" @click="resetQuery('query')"
          >清空</el-button
        >
        <el-button type="primary" size="small" @click="handleQuery"
          >确定</el-button
        >
        <el-button type="primary" size="small" @click="isShowQuery = false"
          >关闭</el-button
        >
      </el-form-item>
    </el-form>
    <el-row type="flex" justify="start" align="middle">
      <el-col :span="20" style="margin-left: 10px">
        <el-button
          size="small"
          @click="addTab"
          style="margin-bottom: 10px"
          type="primary"
          v-if="userType === '1'"
          >增加课件类别</el-button
        >
        <el-button size="small" type="primary" @click="isShowQuery = true"
          >搜索</el-button
        >
        <el-button size="small" type="primary" @click="addCourse(1, '')"
          >添加</el-button
        >
        <el-button size="small" type="primary" @click="closeUse"
          >禁用</el-button
        >
        <el-button size="small" type="primary" @click="outExcel"
          >下载</el-button
        >
        <el-button size="small" type="primary" @click="deleteList"
          >删除</el-button
        >
        <!--        <el-button  size="small" type="primary" @click="showColumn">显示列</el-button>-->
        <el-button size="small" type="primary" @click="dialogVisible = true"
          >导入课件列表</el-button
        >
        <!--        <el-button  size="small" type="primary" @click="showAnalysis">数据分析</el-button>-->
        <el-button size="small" type="primary" @click="showQuestionsDialog"
          >打开试题列表</el-button
        >
        <el-button size="small" type="primary" @click="showExamsDialog"
          >打开试卷列表</el-button
        >
      </el-col>
    </el-row>
    <el-table
      ref="table"
      :data="tableData"
      id="courseTable"
      border
      style="width: 100%"
      @selection-change="handleSelectionChange"
      size="small"
      :header-cell-style="{ 'background-color': '#e8eff9' }"
      @sort-change="sortChange"
    >
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column label="id" prop="id" v-if="false"></el-table-column>
      <el-table-column prop="sort" width="80" label="序号" sortable="custom">
      </el-table-column>
      <el-table-column prop="uname" label="创建人"></el-table-column>
      <el-table-column prop="knowledgeName" label="知识点"></el-table-column>
      <el-table-column prop="title" label="名称"></el-table-column>
      <el-table-column prop="teacherName" label="讲师"></el-table-column>
      <el-table-column prop="typeName" label="类别"></el-table-column>
      <el-table-column prop="cites" label="引用量"></el-table-column>
      <el-table-column prop="type" label="类型">
        <template #default="scope">
          <span v-if="scope.row.type == '1'">视频</span>
          <span v-if="scope.row.type == '2'">音频</span>
          <span v-if="scope.row.type == '3'">文本</span>
          <span v-if="scope.row.type == '4'">文档</span>
          <span v-if="scope.row.type == '5'">音视频链接</span>
        </template>
      </el-table-column>
      <el-table-column prop="ctime" label="创建时间" :formatter="formatDate2">
        <!--        <template slot-scope="scope">-->
        <!--          <div>{{ scope.row.ctime | formatDate}}</div>-->
        <!--        </template>-->
      </el-table-column>
      <el-table-column
        prop="updateTime"
        label="更新时间"
        :formatter="renderTime"
      >
        <!--        <template slot-scope="scope">-->
        <!--          <div>{{scope.row.updateTime | getTime }}</div>-->
        <!--        </template>-->
      </el-table-column>
      <el-table-column prop="status" label="启/禁用">
        <template #default="scope">
          <span v-if="scope.row.status == '0'" style="color: red">禁用</span>
          <span v-if="scope.row.status == '1'">启用</span>
        </template>
      </el-table-column>
      <el-table-column prop="returnReason" label="退回原因" v-if="reason">
        <template slot-scope="scope">
          <div>{{ scope.row.updateTime | getTime }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态">
        <template #default="scope">
          <span
            class="operation"
            @click="showRegistrationReviewEdit(scope.row)"
          >
            <span v-if="scope.row.status == '0'" style="color: red">禁用</span>
            <span v-if="scope.row.status == '1'">
              <span v-if="scope.row.wareStatus == '0'">审核中</span>
              <span v-if="scope.row.wareStatus == '1'" style="color: green"
                >正常</span
              >
              <span v-if="scope.row.wareStatus == '2'" style="color: red"
                >退回</span
              >
            </span>
          </span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="300">
        <template #default="scope">
          <span
            class="operation"
            @click="
              showCourseDetail(
                scope.row.id,
                scope.row.wareStatus,
                scope.row.returnReason
              )
            "
            >预览</span
          >
          <span class="operation" @click="edit(2, scope.row.id)">编辑</span>
          <span
            class="operation"
            @click="isPause(scope.row.id, scope.row.status, scope.row)"
            >启/停用</span
          >
          <span class="operation" @click="deleteSelf(scope.row)">删除</span>
          <span
            class="operation"
            @click="showAnalysis(scope.row.id, scope.row.title)"
            >使用情况</span
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageObj.page"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="pageObj.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      background
      :total="total"
    >
    </el-pagination>

    <el-dialog
      title="导入课件列表"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
      v-if="dialogVisible"
      class="importKj"
    >
      <el-upload
        class="upload-demo"
        :action="url + '/zkfz/zkolVideoData/importExcel'"
        :on-preview="handlePreview"
        :on-remove="handleRemove"
        :on-change="handleChange"
        :before-upload="beforeAvatarUpload"
        :file-list="fileList"
      >
        <el-button size="small" type="primary" style="margin: 0 10px"
          >点击上传</el-button
        >
        <el-button
          size="small"
          type="primary"
          @click="downloadModel()"
          style="margin: 10px 10px 0"
          >下载模板</el-button
        >
        <div slot="tip" class="el-upload__tip" style="margin-left: 10px">
          只能上传excel文件
        </div>
      </el-upload>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="importCourse">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="提示"
      :visible.sync="addCourseVisible"
      width="30%"
      :before-close="handleClose"
    >
      <div>
        增加课件类别：
        <el-input
          placeholder="请选择日期"
          v-model="addTypeName"
          style="width: 70%"
        >
        </el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addCourseVisible = false">取 消</el-button>
        <el-button type="primary" @click="addTypeNames">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :visible.sync="questionsDialogVisible"
      v-if="isQuestionsDialog"
      width="80%"
      :close-on-click-modal="false"
      destroy-on-close
      @close="closeQuestions"
    >
      <iframe
        :src="
          ifUrl +
          '/index.php?app=exams&mod=AdminQuestion&act=index&from_course=1&course_ware_id=' +
          coursewareId
        "
        frameborder="0"
        width="100%"
        height="720px"
      ></iframe>
    </el-dialog>

    <el-dialog
      :visible.sync="examsDialogVisible"
      v-if="isExamsDialog"
      width="80%"
      :close-on-click-modal="false"
      destroy-on-close
      @close="closeExamsDialog"
    >
      <iframe
        :src="
          ifUrl +
          '/index.php?app=exams&mod=AdminPaper&act=index&course_ware_id=' +
          coursewareId
        "
        frameborder="0"
        width="100%"
        height="720px"
      ></iframe>
    </el-dialog>

    <el-button plain @click="tipOpen" v-show="false"> 推送消息 </el-button>

    <Courseware-manager-analysis
      v-if="isShowDialog"
      ref="CoursewareManagerAnalysis"
      @close-registration-review-edit="closeRegistrationReviewEdit"
    ></Courseware-manager-analysis>
    <Courseware-manager-updataList
      v-if="isShowUpdate"
      ref="CoursewareManagerUpdataList"
    ></Courseware-manager-updataList>
    <Courseware-manager-column
      v-if="isShowDialogNotPass"
      ref="CoursewareManagerColumn"
      @showColumn="isShowColumn"
    ></Courseware-manager-column>
    <Courseware-manager-add
      :key="timer"
      v-if="addDialog"
      :courseWareId="courseWareId"
      @closeAddCourse="closeAddCourse"
      ref="CoursewareManagerAdd"
    ></Courseware-manager-add>
    <Verify-edit v-if="verifyDialog" ref="VerifyEdit"></Verify-edit>
    <Courseware-manager-preview
      v-if="previewDialog"
      ref="CoursewareManagerPreview"
      @gotoChangePage="gotoChangePage"
      @gotoUpdata="gotoUpdata"
      @gotoEdit="gotoEdit"
    ></Courseware-manager-preview>
  </div>
</template>

<script>
import { confirmMsg } from '@/utils/common'
import * as api from '@/api/courseware/checkCourseware'
import CoursewareManagerAnalysis from './CoursewareManager-analysis'
import CoursewareManagerColumn from './CoursewareManager-column'
import CoursewareManagerAdd from './CoursewareManager-add'
import CoursewareManagerPreview from './CoursewareManager-preview'
import CoursewareManagerUpdataList from './CoursewareManager-updataList'
import VerifyEdit from './Verify-edit'
export default {
  inject: ['reload'],
  name: 'RegistrationReview',
  components: {
    CoursewareManagerAnalysis,
    CoursewareManagerColumn,
    CoursewareManagerAdd,
    VerifyEdit,
    CoursewareManagerPreview,
    CoursewareManagerUpdataList,
  },
  props: ['courseWareId'],
  data() {
    return {
      coursewareId: this.courseWareId || this.$route.query.id,
      userType: '',
      institutionId: '',
      reason: false,
      previewDialog: false,
      columnArr: [],
      columnShow: true,
      downLoadUrl: '',
      verifyDialog: false,
      chooseTypes: false,
      notTypes: true,
      timer: '',
      addTypeName: '',
      addCourseVisible: false,
      addDialog: false,
      fileList: [],
      dialogVisible: false,
      activeName: 'first',
      loading: false,
      reviewStatus: '2',
      reviewStatusList: [
        { value: '2', label: '待审核' },
        { value: '1', label: '审核通过' },
        { value: '0', label: '审核未通过' },
      ],
      isShowQuery: false,
      // 课件名称
      categoryList: ['课件名称', '讲师', '类别', '类型', '知识点'],
      optionType: ['视频', '音频', '文本', '文档', '音视频链接'],
      query: {
        professionId: '',
        courseName: '',
        admissionCard: '',
        uName: '',
        datetime: [],
        typeName: '',
      },
      tableData: [],
      // 分页
      pageObj: {
        page: 1,
        pageSize: 20,
      },
      // 总数
      total: 0,
      // 选中的数组
      selectedList: [],
      isShowDialog: false,
      isShowUpdate: false,
      isShowDialogNotPass: false,
      dialogArr: [],
      editableTabsValue: '全部',
      editableTabs: [],
      tabIndex: 5,
      questionsDialogVisible: false,
      isQuestionsDialog: false,
      examsDialogVisible: false,
      isExamsDialog: false,
      orderBy: '',
    }
  },
  methods: {
    //通过uid获取用户
    getUserByUid() {
      const uid = this.getUId
      api.getUserByUid(uid).then(({ data }) => {
        if (data.code === 100000) {
          this.userType = data.data.type
          this.getSchoolByUid()
        }
      })
    },
    //通过uid获取机构
    getSchoolByUid() {
      const uid = this.getUId
      api.getSchoolByUid(uid).then(({ data }) => {
        if (data.code === 100000) {
          this.institutionId = data.data.id
          this.getList()
        }
      })
    },
    beforeAvatarUpload(file) {
      // const isJPG = file.type === 'image/jpeg';
      var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = testmsg === 'xls'
      const extension2 = testmsg === 'xlsx'
      const isLt2M = file.size / 1024 / 1024 < 1024

      // if (!isJPG) {
      //   this.$message.error('上传头像图片只能是 JPG 格式!');
      // }
      if (!extension && !extension2) {
        this.$message.error('只能上传excel文件！')
        return false
      }
      if (!isLt2M) {
        this.$message.error('文件大小不能超过 1G!')
      }
      // return isJPG && isLt2M;
      return (extension || extension2) && isLt2M
    },

    handleChange(file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1)
      }
      this.file = file.raw
    },

    importCourse() {
      let formdata = new FormData()
      formdata.append('file', this.file)
      const id = this.courseWareId || this.$route.query.id
      formdata.append('id', id)
      formdata.append('uid', this.getUId)
      api.importExcel2(formdata).then(({ data }) => {
        // data = data.data
        if (data.data.errorMsg == '') {
          this.$message({ type: 'success', message: '操作成功' })
          this.dialogVisible = false
          this.getList()
        } else {
          this.$message({ type: 'error', message: data.data.errorMsg })
        }
      })
    },

    gotoUpdata(data) {
      this.isShowUpdate = true
      this.$nextTick(() => {
        this.$refs.CoursewareManagerUpdataList.init(data)
      })
    },

    gotoEdit(data) {
      this.addDialog = true
      this.$nextTick(() => {
        this.$refs.CoursewareManagerAdd.init(2, data)
      })
    },

    // 启/禁用
    isPause(id, status, row) {
      if (row.cites) {
        this.$confirm('有课程正在使用课件', '温馨提示', {
          confirmButtonText: '查看使用情况',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            this.showAnalysis(row.id, row.title)
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消',
            })
          })
      } else {
        let setStatus
        if (status == '0') {
          //禁用
          setStatus = 1
          this.$confirm('是否启用此课件?', '温馨提示', {
            confirmButtonText: '启用',
            cancelButtonText: '取消',
          })
            .then(() => {
              api.setStatus({ ids: id, status: setStatus }).then(({ data }) => {
                // data = data.data
                if (data.code == 100000) {
                  this.getList()
                }
              })
              this.$message({
                type: 'success',
                message: '启用成功!',
              })
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: '已取消',
              })
            })
        } else {
          //启用
          setStatus = 0
          this.$confirm('是否禁用此课件?', '温馨提示', {
            confirmButtonText: '禁用',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(() => {
              api.setStatus({ ids: id, status: setStatus }).then(({ data }) => {
                // data = data.data
                if (data.code == 100000) {
                  this.getList()
                }
              })
              this.$message({
                type: 'success',
                message: '禁用成功!',
              })
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: '已取消',
              })
            })
        }
      }
    },

    chooseCourseName() {
      this.query.courseName = ''
      if (this.query.professionId + 1 == '4') {
        this.chooseTypes = true
        this.notTypes = false
      } else {
        this.chooseTypes = false
        this.notTypes = true
      }
    },

    //      批量禁用
    closeUse() {
      const alldata = this.$refs.table.selection
      let allId = ''
      let flag = false
      for (let i of alldata) {
        if (i.status === 0) {
          return this.$message.error('勾选中存在已禁用')
        }
        if (i.cites) {
          flag = true
        }
      }
      if (flag) {
        this.$confirm('有课程正在使用课件', '温馨提示', {
          confirmButtonText: '查看使用情况',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            this.showAnalysis(alldata[0].id, alldata[0].title)
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消',
            })
          })
      } else {
        confirmMsg('是否禁用此课件？', async () => {
          for (let i of alldata) {
            allId += i.id + ','
          }
          if (alldata.length == 0) {
            this.$message({ type: 'error', message: `请勾选` })
          } else {
            api.setStatus({ ids: allId, status: 0 }).then(({ data }) => {
              // data = data.data
              if (data.code == 100000) {
                this.getList()
                this.$message.success(data.msg)
              } else {
                this.$message.error(data.msg)
              }
            })
          }
        })
      }
    },
    showColumn() {
      this.isShowDialogNotPass = true
      this.$nextTick(() => {
        this.$refs.CoursewareManagerColumn.init()
      })
    },
    showAnalysis(id, title) {
      this.isShowDialog = true
      this.$nextTick(() => {
        this.$refs.CoursewareManagerAnalysis.init(id, title)
      })
    },
    downloadModel() {
      // window.open('/课件列表导入模板.xlsx')
      window.open(
        `http://${window.location.host}/group1/M00/FF/FF/img/模板/课件列表导入模板.xlsx`
      )
    },
    handleClose() {
      this.dialogVisible = false
      this.addCourseVisible = false
    },
    handleRemove(file, fileList) {},
    handlePreview(file) {},

    getinstitutionList() {
      api.getinstitutionList().then(({ data }) => {
        // data = data.data
      })
    },
    addTab() {
      this.addCourseVisible = true
      this.addTypeName = ' '
    },
    addTypeNames() {
      api
        .saveOrUpdate({
          typeName: this.addTypeName,
          remark: '',
          createId: this.getUId,
          institutionId: '1',
        })
        .then(({ data }) => {
          // data = data.data
          this.getTypeList()
        })
      this.addCourseVisible = false
    },
    handleClick(event) {
      const { page, pageSize } = this.pageObj
      if (this.editableTabsValue == '全部') {
        api
          .getList2({
            page,
            pageSize,
            courseWareId: this.coursewareId,
            userType: this.userType,
            institutionId: this.institutionId,
            uid: this.getUId,
          })
          .then(({ data }) => {
            data = data.data
            this.total = data.total
            this.tableData = data.list
          })
      } else {
        api
          .getList3({
            page,
            pageSize,
            courseWareId: this.coursewareId,
            courseWareType: this.editableTabsValue,
            userType: this.userType,
            institutionId: this.institutionId,
            uid: this.getUId,
          })
          .then(({ data }) => {
            data = data.data
            this.total = data.total
            this.tableData = data.list
          })
      }
    },
    removeTab(targetName) {
      let tabs = this.editableTabs
      let activeName = this.editableTabsValue
      if (activeName === targetName) {
        tabs.forEach((tab, index) => {
          if (tab.name === targetName) {
            let nextTab = tabs[index + 1] || tabs[index - 1]
            if (nextTab) {
              activeName = nextTab.name
            }
          }
        })
      }
      this.editableTabsValue = activeName
      this.editableTabs = tabs.filter((tab) => tab.name !== targetName)
    },
    showCourseDetail(row, wareStatus, returnReason) {
      this.previewDialog = true
      this.$nextTick(() => {
        this.$refs.CoursewareManagerPreview.init(row, wareStatus, returnReason)
      })
    },

    edit(type, id) {
      this.addDialog = true
      this.$nextTick(() => {
        this.$refs.CoursewareManagerAdd.init(2, id)
      })
    },

    gotoChangePage(data) {
      this.addDialog = true
      this.$nextTick(() => {
        this.$refs.CoursewareManagerAdd.init(2, data)
      })
    },

    addCourse(type, id) {
      //type：1添加 2编辑  id：编辑的对象id
      this.addDialog = true
      this.timer = new Date().getTime() //每次点击都重新加载
      this.$nextTick(() => {
        this.$refs.CoursewareManagerAdd.init(1, '')
      })
    },
    closeAddCourse() {
      this.getList()
      this.$emit('updateVerifyList')
      this.addDialog = false
    },
    //      查看提醒跳转
    checkCourseTip() {},
    //    忽略提醒
    ignore() {},
    tipOpen() {
      const h = this.$createElement
      this.dialogArr.push(
        this.$notify({
          message: h('p', null, [
            h(
              'p',
              {
                style: {
                  color: 'red',
                  textAlign: 'center',
                },
              },
              '温馨提示，：请完善英语课件库内容 '
            ),
            h(
              'a',
              {
                style: {
                  padding: '8px 20px',
                  margin: '10px 12px 0px 2px',
                  textAlign: 'center',
                  textDecoration: 'none',
                  display: 'inline-block',
                  webkitTransitionDuration: '0.4s',
                  transitionDuration: '0.4s',
                  cursor: 'pointer',
                  backgroundColor: 'blue',
                  color: '#fff',
                  border: '1px solid #e7e7e7',
                },
                on: {
                  click: this.checkCourseTip,
                },
              },
              '查看'
            ),
            h(
              'button',
              {
                style: {
                  padding: '8px 20px',
                  margin: '10px 12px 0px 2px',
                  textAlign: 'center',
                  textDecoration: 'none',
                  display: 'inline-block',
                  webkitTransitionDuration: '0.4s',
                  transitionDuration: '0.4s',
                  cursor: 'pointer',
                  backgroundColor: 'blue',
                  color: '#fff',
                  border: '1px solid #e7e7e7',
                },
                on: {
                  click: this.ignore,
                },
              },
              '忽略'
            ),
          ]),

          position: 'top-right',
          duration: 0,
        })
      )
    },
    // 监听状态切换
    handleReviewStatusChange() {
      this.pageObj.page = 1
      this.getList()
    },

    // 获取数据
    getList() {
      this.loading = true
      const { page, pageSize } = this.pageObj
      this.editableTabsValue = '全部'
      api
        .getList2({
          page,
          pageSize,
          courseWareId: this.coursewareId,
          userType: this.userType,
          institutionId: this.institutionId,
          uid: this.getUId,
          orderBy: this.orderBy,
        })
        .then(({ data }) => {
          data = data.data
          this.total = data.total
          this.tableData = data.list
          this.loading = false
        })
      // this.getinstitutionList()
    },

    // 时间戳转日期
    formatDate2(row, column, cellValue, index) {
      if (cellValue == null || cellValue == '') return ''
      let date = new Date(parseInt(cellValue) * 1000) //时间戳为10位需*1000，如果为13位的话不需乘1000。
      let Y = date.getFullYear() + '-'
      let M =
        date.getMonth() + 1 < 10
          ? '0' + (date.getMonth() + 1) + '-'
          : date.getMonth() + 1 + '-'
      let D =
        date.getDate() < 10 ? '0' + date.getDate() + ' ' : date.getDate() + ' '
      let h =
        date.getHours() < 10
          ? '0' + date.getHours() + ':'
          : date.getHours() + ':'
      let m =
        date.getMinutes() < 10
          ? '0' + date.getMinutes() + ':'
          : date.getMinutes() + ':'
      let s =
        date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
      return Y + M + D + h + m + s
    },

    // 标准时间转日期
    renderTime(date) {
      if (
        date.updateTime == null ||
        date.updateTime == undefined ||
        date.updateTime == ''
      ) {
        return
      } else {
        var dates = new Date(date.updateTime).toJSON()
        return new Date(+new Date(dates) + 8 * 3600 * 1000)
          .toISOString()
          .replace(/T/g, ' ')
          .replace(/\.[\d]{3}Z/, '')
      }
    },

    // 获取类别
    getTypeList() {
      const { page, pageSize } = this.pageObj
      api.getList({ page, pageSize }).then(({ data }) => {
        data = data.data
        this.editableTabs = data.list
      })
    },

    //    个别删除
    deleteSelf(row) {
      if (row.cites) {
        this.$confirm('有课程正在使用课件', '温馨提示', {
          confirmButtonText: '查看使用情况',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            this.showAnalysis(row.id, row.title)
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消',
            })
          })
      } else {
        confirmMsg('是否删除该条数据？', async () => {
          api.deleteList(row.id).then(({ data }) => {
            if (data.code == 100000) {
              this.$message({ type: 'success', message: `删除成功` })
              this.getList()
            }
          })
        })
      }
    },

    // 批量删除
    deleteList() {
      const selectedList = this.selectedList
      let ids = ''
      let flag = false
      if (selectedList.length === 0) {
        return this.$message({
          type: 'warning',
          message: '请先选择需要操作的数据',
        })
      } else {
        for (let i of selectedList) {
          if (i.cites) {
            flag = true
          } else {
          }
        }
        if (flag) {
          this.$confirm('有课程正在使用课件', '温馨提示', {
            confirmButtonText: '查看使用情况',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(() => {
              this.showAnalysis(selectedList[0].id, selectedList[0].title)
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: '已取消',
              })
            })
        } else {
          confirmMsg('是否删除这些数据？', async () => {
            for (let i = 0; i < selectedList.length; i++) {
              ids += selectedList[i].id + ','
            }
            api.deleteList(ids).then(({ data }) => {
              if (data.code == 100000) {
                this.$message({ type: 'success', message: `删除成功` })
                // this.getList()
                this.getList()
              }
            })
          })
        }
      }
    },

    // 导出通过
    outExcel() {
      // this.loading = true
      const selectedList = this.selectedList
      let ids = ''
      if (selectedList.length === 0) {
        return this.$message({
          type: 'warning',
          message: '请先选择需要操作的数据',
        })
      } else {
        confirmMsg('是否下载选中课件？', async () => {
          for (let i of selectedList) {
            ids += i.id + ','
          }
          window.open(
            this.url + '/zkfz/zkolVideoData/exportAccessory?ids=' + ids
          )
        })
        this.getList()
      }
    },

    downLoad(url) {
      let eleLink = document.createElement('a')
      eleLink.download = url
      eleLink.href = url
      eleLink.click()
      eleLink.remove()
    },

    // 处理选中事件
    handleSelectionChange(arr) {
      this.selectedList = arr
    },
    //序号排序
    sortChange({ order }) {
      if (order === 'descending') {
        this.orderBy = 'desc'
      } else {
        this.orderBy = 'asc'
      }
      this.getList()
    },
    // 改变页面接收数据大小
    handleSizeChange(val) {
      this.pageObj.pageSize = val
      this.getList()
    },

    // 改变当前页面
    handleCurrentChange(val) {
      this.pageObj.page = val
      this.getList()
    },

    // 查询
    handleQuery() {
      this.pageObj.page = 1
      const orderBy = 'asc'
      api
        .getList4(
          this.pageObj.page,
          this.pageObj.pageSize,
          this.query.professionId + 1,
          this.query.courseName,
          this.coursewareId,
          this.userType,
          this.institutionId,
          this.getUId,
          orderBy
        )
        .then(({ data }) => {
          data = data.data
          this.tableData = data.list
          this.total = data.total
        })
    },

    // 重置查询
    resetQuery(formName) {
      this.$refs[formName].resetFields()
      this.handleQuery()
    },

    // 查看报名信息
    showRegistrationReviewEdit(row) {
      this.isShowDialog = true
      this.$nextTick(() => {
        //        this.$refs.registrationReviewEdit.init(row, this.reviewStatus, this.getUId)
      })
    },

    isShowColumn(msg) {
      // let parents = document.getElementById('courseTable')
      this.columnArr = msg
    },

    closeRegistrationReviewEdit() {
      this.isShowDialog = false
    },
    showQuestionsDialog() {
      this.isQuestionsDialog = true
      this.questionsDialogVisible = true
    },
    closeQuestions() {
      this.isQuestionsDialog = false
      this.questionsDialogVisible = false
    },
    showExamsDialog() {
      this.isExamsDialog = true
      this.examsDialogVisible = true
    },
    closeExamsDialog() {
      this.isExamsDialog = false
      this.examsDialogVisible = false
    },
  },
  created() {
    this.getTypeList()
    this.getUserByUid()
  },
  computed: {
    getUId() {
      return localStorage.getItem('uid') 
    },
    url() {
      let url = window.location.protocol + '//' + window.location.host
      if (window.location.host == 'localhost:5001') {
        url = 'http://gz.hnjk.net'
      }
      return url
    },
    ifUrl() {
      let url = window.location.protocol + '//' + window.location.host
      if (window.location.host == 'localhost:5001') {
        url = 'http://gz.hnjk.net'
      }
      if (window.location.host == 'fxl.sce.scut.edu.cn') {
        url = url + '/zk'
      }
      return url
    },
  },
  filters: {
    formatDate: function (value) {
      let date = new Date(value)
      let y = date.getFullYear()
      let MM = date.getMonth() + 1
      MM = MM < 10 ? '0' + MM : MM
      let d = date.getDate()
      d = d < 10 ? '0' + d : d
      let h = date.getHours()
      h = h < 10 ? '0' + h : h
      let m = date.getMinutes()
      m = m < 10 ? '0' + m : m
      let s = date.getSeconds()
      s = s < 10 ? '0' + s : s
      return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s
    },
    getTime(time) {
      let date = new Date(time)
      let y = date.getFullYear()
      let m =
        date.getMonth() + 1 < 10
          ? '0' + (date.getMonth() + 1)
          : date.getMonth() + 1
      let d = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
      return y + '-' + m + '-' + d
    },
  },
}
</script>

<style lang="scss" scoped>
/deep/.el-tabs__item {
  font-size: 12px;
}
/deep/.el-tabs__item {
  padding: 0 10px !important;
}
/deep/.el-pagination.is-background .btn-next,
/deep/.el-pagination.is-background .btn-prev,
/deep/.el-pagination.is-background .el-pager li {
  background-color: #e2e8f4;
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #265480;
}
</style>
<style>
.el-notification__content {
  text-align: center;
}
/*.el-tabs__nav .el-tabs__item:nth-child(-n+5) span{*/
/*  display: none;*/
/*}*/
.importKj .el-dialog__body {
  text-align: center;
}
</style>
